import axios from "axios";
import { API } from "@/lib/faro";
import { logDev } from "@/lib/log";

// Session id stored in sessionStorage (per tab)
function getSessionId() {
  try {
    let sid = sessionStorage.getItem("faro_sid");
    if (!sid) {
      sid = (crypto?.randomUUID?.() || `s_${Date.now()}_${Math.random().toString(36).slice(2)}`);
      sessionStorage.setItem("faro_sid", sid);
    }
    return sid;
  } catch {
    return "anon";
  }
}

/**
 * Track a user-facing interaction.
 * type: "whatsapp" | "phone" | "form_submit_contact" | "form_submit_puntos" | "cta_matriculate" | "cta_next_course"
 * meta: { center, page, ...anything }
 */
export function trackClick(type, meta = {}) {
  const payload = {
    type,
    center: meta.center || null,
    page: meta.page || (typeof window !== "undefined" ? window.location.pathname + window.location.hash : null),
    session_id: getSessionId(),
    referrer: typeof document !== "undefined" ? document.referrer || null : null,
    meta: meta.extra || null,
  };
  // Own backend
  axios.post(`${API}/track/click`, payload).catch(() => {});
  // Google Analytics (if loaded)
  try {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", type, {
        center: payload.center || undefined,
        page: payload.page || undefined,
      });
    }
  } catch (err) {
    logDev("GA no disponible:", err);
  }
}

export function trackPageView(path) {
  try {
    if (typeof window !== "undefined" && typeof window.gtag === "function" && window.__FARO_GA_ID__) {
      window.gtag("config", window.__FARO_GA_ID__, { page_path: path });
    }
  } catch (err) {
    logDev("GA no disponible:", err);
  }
}

/** Load Google Analytics 4 (gtag.js) once, given a measurement id like "G-XXXXXXX". */
export function initGA(measurementId) {
  if (!measurementId) return;
  if (typeof window === "undefined") return;
  if (window.__FARO_GA_ID__ === measurementId && window.gtag) return; // already initialised
  window.__FARO_GA_ID__ = measurementId;

  const existing = document.getElementById("faro-ga-script");
  if (!existing) {
    const s = document.createElement("script");
    s.id = "faro-ga-script";
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    document.head.appendChild(s);
  }
  window.dataLayer = window.dataLayer || [];
  // eslint-disable-next-line prefer-rest-params
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", measurementId, { send_page_view: true });
}
